export const metricTileCardBase =
  "flex min-w-0 flex-col rounded-lg border transition-all cursor-pointer overflow-hidden";

export const metricTileStandardCard =
  "bg-gradient-to-b from-slate-800 to-slate-900 border-slate-700 hover:border-indigo-500/40";

export const metricTileInner =
  "flex min-w-0 flex-1 flex-col items-center justify-center p-3 md:p-4 2xl:p-5";

export const metricTileTitle =
  "max-w-full text-center text-[9px] font-semibold uppercase tracking-wide text-white md:text-[10px] 2xl:text-xs 2xl:tracking-wider mb-2";

export const metricTileValueBase =
  "w-full max-w-full flex justify-center mb-2 2xl:mb-4";

export const metricTileValueText =
  "inline-block whitespace-nowrap text-center font-bold leading-none tabular-nums tracking-tight text-[1.65rem] md:text-[1.7rem] lg:text-[1.85rem] 2xl:text-5xl";

export const metricTileValueDefault = `${metricTileValueText} text-white`;

export const metricTileDescription =
  "line-clamp-2 max-w-full text-center text-[9px] font-semibold uppercase tracking-wide text-orange-400 md:text-[10px] 2xl:text-xs 2xl:tracking-wider";

export const metricTileDisruptionActiveCard =
  "bg-gradient-to-b from-amber-400/20 to-amber-500/10 border-amber-400/40 hover:border-amber-300/50";

export const metricTileDisruptionActiveValue = `${metricTileValueText} text-amber-300`;
